@if (localeList) {
  <p-select
    (onChange)="onLocaleChange($event)"
    [options]="localeList"
    [(ngModel)]="locale"
    [placeholder]="locale"
    [showClear]="showClear()"
    [filter]="true"
    filterBy="label, value"
  >
  </p-select>
}
